module.exports = __webpack_public_path__ + "img/seminar (58).ec9c57a6.jpg";